<template>
	<div>
		<div v-if="!loaded_phones">
			<button type="button" @click="showPhoneNumbers()" class="btn btn-block m-t-15 btn-lg btn-custom waves-effect waves-light ladda-button">
				<span class="ladda-label">Ver telefones de {{ name }}</span>
			</button>

            <p v-if="!active_premium" class="text-mutted m-t-20">
                Iremos debitar <span class="coins-amount">{{ view_phone_amount }}<img src="/images/icone_moeda.svg" alt="Coin Icon"></span>
                de sua conta, caso o telefone de {{ name }} esteja disponível. <a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/128-o-que-sao-as-moedas-webquarto">Clique aqui</a>
                para saber mais sobre as moedas do WebQuarto.
            </p>
		</div>

        <div v-else>
            <div v-if="has_phones">
                <div v-if="phone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Telefone</p>
                        <h3 class="m-b-10"><i class="fas fa-phone pull-left"></i> <span>{{ phone }}</span></h3>
                    </div>
                </div>

                <div v-if="cellphone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Celular</p>
                        <h3 class="m-b-10"><i class="fas fa-mobile-alt pull-left"></i> <span>{{ cellphone }}</span></h3>
                    </div>
                </div>

                <div class="alert alert-success">
                    <p class="text-dark">
                        Não se esqueça de dizer para {{ name }} que você conseguiu seu número pelo WebQuarto. :)
                    </p>
                </div>
            </div>

            <div v-if="hidden_phones">
                <div class="alert alert-info">
                    <p class="text-dark">
                        {{ name }} optou por não exibir seus números de telefone. Você ainda pode entrar em contato enviando uma mensagem pelo campo acima.
                    </p>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	var Ladda = require('../../../../../../legacy/node_modules/ladda');
	export default {
		props: {
			name: {
				required: true
			},
			fk_user: {
				required: true
			},
			type: {
				required: true
			},
			active_premium: {
				required: true
			},
			view_phone_amount: {
				required: true
			}
		},
		data: function () {
			return {
				has_phones: false,
                loaded_phones: false,
                hidden_phones: false,
				phone: '',
				cellphone: ''
			};
		},

		methods: {
			showPhoneNumbers: function () {
				var instance = this;
				let l = Ladda.create( instance.$el.querySelector('.ladda-button') );
				l.start();
				axios.get('/user/get-phonenumbers/' + this.fk_user + '/roommate_ad').then(function (response) {
					l.stop();
					var data = response.data;
					if (data.success) {
						instance.phone = data.phone;
						instance.cellphone = data.cellphone;

						instance.has_phones = data.has_phones;
						instance.loaded_phones = true;

						window.dataLayer.push({
							'event': 'show_phone_number',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else {
						const error = data.error ?? data.msg;

                        switch (error) {
                            case 'hidden_phone':
                                instance.hidden_phones = true;
                                instance.loaded_phones = true;
                                break;
                            case 'insuficient_credits':
                                EventBus.$emit('open-modal', 'need-credits-modal');
                                break;
                            case 'need_mobile_verification':
                                EventBus.$emit('open-modal', 'verify-mobile-modal');
                                break;
                            default:
                                window.App.error('Não foi possível visualizar o telefone dessa pessoa. Entre em contato com nossa equipe de suporte!');
                        }
					}
				}).catch(function (error) {
					l.stop();
					if (error.response && error.response.status == 401) {
						EventBus.$emit('open-modal', 'register-modal', {name: instance.name});
						window.dataLayer.push({
							'event': 'show_login_modal',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else
						window.App.error('Ocorreu um erro inesperado. Atualize esta página e tente novamente!');
				});
			}
		},

		created() {
		}
	}
</script>

<style lang="scss" scoped>
    .coins-amount {
        font-weight: bolder;
        color: #5f6261;

        img {
            margin-left: 4px;
            width: 14px;
            height: 14px;
        }
    }
</style>
